import React from 'react';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../util/routes';

import HeroSearchForm from './HeroSearchForm';

import css from './HeroSearch.module.css';

const HeroSearch = props => {
  const { className, rootClassName } = props;

  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();

  const handleSubmitSearch = (values, form) => {

    if (values?.listingType === "educators") {
      history.push(createResourceLocatorString(
        "SearchPageEducators",
        routeConfiguration,
        {},
        { keywords: values?.keywords })
      );
    }

    if (values?.listingType === "workshops") {
      history.push(createResourceLocatorString(
        "SearchPageWorkshops",
        routeConfiguration,
        {},
        { keywords: values?.keywords })
      );
    }
  }

  return (
    <div className={css.root}>
      <HeroSearchForm
        initialValues={{ listingType: 'educators' }}
        name='searchEducators'
        className={css.searchEducators}
        onSubmit={handleSubmitSearch}
      />

      <HeroSearchForm
        initialValues={{ listingType: 'workshops' }}
        name='searchWorkshops'
        className={css.searchWorkshops}
        onSubmit={handleSubmitSearch}
      />
    </div>
  );
};

export default HeroSearch;
